// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from '../../i18n/I18n';


class SubmitArea extends Component {

  static propTypes = {
    haveModifications: PropTypes.bool.isRequired,

    onSubmit: PropTypes.func.isRequired,

    onReset: PropTypes.func.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.haveModifications !== this.props.haveModifications;
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(event);
  };

  onReset = (event) => {
    event.preventDefault();
    this.props.onReset(event);
  };

  get haveModifications(): boolean {
    return this.props.haveModifications;
  }

  render() {
    if (!this.haveModifications) {
      return null;
    }
    return (
      <div className="submit_area">

        <button
          className="btn"
          onClick={this.onReset}
          type="reset"
        >
          {I18n.tr('components.submit_area.cancel')}
        </button>

        &nbsp;&nbsp;&nbsp;&nbsp;

        <button
          className="btn btn-primary"
          onClick={this.onSubmit}
          type="submit"
        >
          {I18n.tr('components.submit_area.save')}
        </button>
      </div>
    );
  }

}

export default SubmitArea;
